import React, { useEffect, useMemo, useRef, useState } from "react";
import {motion} from "framer-motion";
import {
	Card, CardBody, CardFooter, Row, Col, CardHeader, Button, Input, Label, FormGroup, Form, ModalHeader,
	ModalBody,	
    ModalFooter,
	Modal,
} from "reactstrap";
import RefStrap from "lib/Utils/RefStrap";
import {isNumber} from "chart.js/helpers";
import Brand from "../lib/Core/Backend/Controllers/Brand";
import CardType from "../lib/Core/Backend/Controllers/CardType";
import Supplier from "lib/Core/Backend/Controllers/Supplier";
import DataTable from "components/Core/DataTable";
import Select from "react-select";
import FormValidator from "lib/Utils/FormValidator";
import NotificationAlert from "react-notification-alert";
import "../assets/scss/react/_buttons.scss"
import Notify from "lib/Utils/Alert";

const MotionCard = motion(RefStrap(Card));
const cardControl = {
	animate: {
		transition: {
			delayChildren: 0.05, staggerChildren: 0.1, staggerDirection: 1
		}
	}
}
const fadeIn = {
	initial: {opacity: 0, scale: 0.6}, animate: {opacity: 1, scale: 1, transition: {duration: 0.2, ease: "easeOut"}},
};

// const DiscountsFeesCard = (props) => (
// 	<MotionCard variants={fadeIn} className='card-stats'>
// 		<CardHeader className='brandStatsHeaderContainer'>
// 			<div className="icon-big text-left icon-warning">
// 				<i className="nc-icon nc-globe text-success"/>
// 			</div>
// 			<p className="card-category brandStatsHeaderTitle">Best supplier for this brand</p>
// 		</CardHeader>

// 		<CardBody className='brandStatsBodyContainer'>
// 			<div style={{ flex: 1, textAlign: 'center' }}>
// 				<p id="brandName" className="card-category" style={{ textAlign: 'center' }}>{props.brandName}</p>
// 				<img id="brandLogo" alt="Brand logo" style={{width: "auto", maxWidth: "180px"}} src={props.brandLogoUrl}/>
// 			</div>

// 			<div className='brandStatsDiscountsTableContainer'>
// 				<table className='brandStatsDiscountsTable'>
// 					<thead>
// 						<tr>
// 							<th></th>
// 							<th>Supplier</th>
// 							<th>Gift Card</th>
// 							<th>Discount</th>
// 							<th>Fee</th>
// 						</tr>
// 					</thead>
// 					<tbody>
// 						{ props.discountInformation.map((discount, index) => (
// 							<tr key={index} className='space-between-items'>
// 								<th>{index + 1}.</th>
// 								<th>{discount.supplierName}</th>
// 								<th><span>45 gift cards</span></th>
// 								<th>{discount.purchaseDiscount}%</th>
// 								<th>${discount.purchaseFee}</th>
// 							</tr>
// 						)) }
// 					</tbody>
// 				</table>
// 			</div>
// 		</CardBody>

// 		<CardFooter className="brandStatsFooterContainer">
// 			<hr/>
// 			<div className="stats">
// 				<i className="far fa-calendar"/>~{props.lastUpdate}<span id="lastUpdate"/>
// 			</div>
// 		</CardFooter>
// 	</MotionCard>
// )

function BrandDashboard(props)
{
	const {token,setTitle} = props;
	const brandId = props.match.params.id;
	const brandCtl = useMemo(() => new Brand(token), [token]);
	const cardCtl = useMemo(() => new CardType(token), [token]);
	const supplierCtl = useMemo(() => new Supplier(token), [token]);
	const [cards, setcards] = useState([]);
	const [discountInformation, setDiscountInformation] = useState([])
	const [brandLogoUrl, setBrandLogoUrl] = useState(null)
	const [brandName, setBrandName] = useState('')
	const [lastUpdate, setLastUpdate] = useState(null)
	const [operation, setOperation] = useState('');
	const [supplierWithPriority, setSupplierWithPriority] = useState(null);
	const [brandSuppliers, setBrandSuppliers] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [giftCardData,setGiftCardData] = useState([]);
	const [detailsData,setDetilsData] = useState([]);
	const [giftModal,setGiftModal] = useState(false);
    const [showConfirm,setShowConfirm] = useState(false)
	const [statusText,setStatusText] = useState("");
	const [statusTextAll,setStatusTextAll] = useState("")
	const [status,setStatus] = useState(null);
	const [statusAll,setStatusAll] = useState(null)
	const [cardId,setCardId] = useState(null);
	const [brnadId,setBrandId] = useState()
	const [allCardIds, setAllCardIds] = useState([]); // Stores all card IDs
	const [allSupplierIds, setAllSupplierIds] = useState([]); 
	const [masterToggle, setMasterToggle] = useState(false); 
	const [showConfirmAll,setShowConfirmAll] = useState(false)
  
	
	
	const toggleConfirm = () => setShowConfirm(!showConfirm);
	const toggleConfirmAll = () => setShowConfirmAll(!showConfirmAll);
    const initialStatus = detailsData.reduce((acc, card) => {
		acc[card.id] = true;
		return acc;
	  }, {});
	
	  const [activationStatus, setActivationStatus] = useState(initialStatus);



	const table = useRef();
	const form = useRef();
	const alert = useRef();
	const select = useRef()

	const header = [
		{title: 'Name', data: 'name', sortable: true, searchable: true},
		{title: 'Total Amount', data: 'totalAmount', sortable: true, searchable: true},
		{title: 'Total Quantity', data: 'totalQuantity', sortable: true, searchable: true},
		{title: 'Status', data: 'status', sortable: true, searchable: true, render: (data) => {
				if(data){
					switch (data) {
						case '1':
							return `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`;
						
						case '2':
							return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;

						case '3':
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;

						case '4': 
							return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
						case '5':
							return `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`;
						default: return 'Error'
					}
				}
			},
		}
	];


	const handleMasterToggle = (e) => {
		const value = e.target.checked;
		setMasterToggle(value);
		setStatusAll(value)
	if(value !== undefined || value !== null){
		toggleConfirmAll()
		if(value){
			setStatusTextAll("Active")
		}else{
			setStatusTextAll("Inactive")
		}
	}
		const newStatus = detailsData.reduce((acc, card) => {
		  acc[card.id] = value;
		  return acc;
		}, {});
		setActivationStatus(newStatus);
	  
		
		const cardIds = detailsData.map((card) => card.id);
		const supplierIds = detailsData.map((card) => card.supplierId);
	  
		
		setAllCardIds(cardIds);
		setAllSupplierIds(supplierIds);
	  
		
	  };

	const supplierPriority = (e) => {
		e.preventDefault();
		if(operation === 'Edit'){
			setOperation('Save');

		} else {
			if(!form.current)
				return

			let today = new Date().getTime();

			const priorityForm = new FormValidator(form.current, (type, message) => Notify(alert, type, message), [
				{label: "Cumulative Value", property: "cumulativeValue", input: "cumulativeValue", required: false, defaultValue: 0},
				{label: "Cumulative Quantity", property: "cumulativeQuantity", input: "cumulativeQuantity", required: false, defaultValue: 0},
				{label: "Time lapse", property: "timeLapse", input: "timeLapse", required: false, defaultValue: 0},
			])

			if(!selectedSupplier){
				Notify(alert, 'danger', 'Select a supplier');
				return;
			}

			if(!priorityForm.isFormValid()){
				return;
			}

			let supplierPriority = priorityForm.getDTO();
			supplierPriority.timeLapse = !!supplierPriority.timeLapse ? new Date(supplierPriority.timeLapse).getTime() : supplierPriority.timeLapse;
			supplierPriority.cumulativeQuantity = parseInt(supplierPriority.cumulativeQuantity);
			supplierPriority.cumulativeValue = parseInt(supplierPriority.cumulativeValue);

			if(!!supplierPriority.timeLapse && today > supplierPriority.timeLapse){
				Notify(alert, 'danger', 'Date cannot be before today')
				return;
			}

			if(supplierPriority.cumulativeValue <= 0){
				Notify(alert, 'danger', 'Please enter a valid cumulative value')
				return;
			}

			if(supplierPriority.cumulativeQuantity <= 0){
				Notify(alert, 'danger', 'Please enter a valid cumulative quantity')
				return;
			}

			supplierCtl.brands(selectedSupplier.value, brandData => {
				if(!(brandData.error || brandData.errorMessage)){
					let supplierBrandId = brandData.find(brand => brand.brandId === parseInt(brandId))?.id ?? null;
					if(!supplierBrandId) return;
					if(operation === 'New'){
						supplierCtl.setSupplierPriority({...supplierPriority, supplierBrandId}, data => {
							if(data.error || data.errorMessage){
								Notify(alert, 'danger', data.errorMessage ?? data.error);
							} else {
								supplierCtl.byId(data.supplierId, supplierData => {
									let currency = new Intl.NumberFormat('en-US', {
										style: 'currency',
										currency: supplierData.currency ?? 'USD'
									});
				
									setSupplierWithPriority({...data, cumulativeValueFormated: currency.format(data.cumulativeValue)});
									setOperation('Edit')
								})
							}
						})
					} else {
						supplierCtl.updateSupplierPriority({...supplierPriority, supplierBrandId, id: supplierWithPriority.id}, data => {
							if(data.error || data.errorMessage){
								Notify(alert, 'danger', data.errorMessage ?? data.error);
							} else {
								supplierCtl.byId(data.supplierId, supplierData => {
									let currency = new Intl.NumberFormat('en-US', {
										style: 'currency',
										currency: supplierData.currency ?? 'USD'
									});
				
									setSupplierWithPriority({...data, cumulativeValueFormated: currency.format(data.cumulativeValue)});
									setOperation('Edit')
								})
							}
						})
					}
				}
			})
		}
	}

	if (!isNumber(brandId))
	{
		Notify("danger", "Brand doesn't exist.");
		window.location.href = "/admin/brands";
	}

	useEffect(() => {
		const newStatus = detailsData.reduce((acc, card) => {
		  acc[card.id] = card.active; 
		  return acc;
		}, {});
		setActivationStatus(newStatus);
	  }, [detailsData]);

	useEffect(() => {
		if(operation === 'Save'){
			if(supplierWithPriority && form.current){
				select.current.selectOption(brandSuppliers.find(supplier => supplier.value === supplierWithPriority.supplierId))
				form.current.cumulativeQuantity.value = supplierWithPriority.cumulativeQuantity;
				form.current.cumulativeValue.value = supplierWithPriority.cumulativeValue;
				if(supplierWithPriority.timeLapse !== 0)
					form.current.timeLapse.value = new Date(supplierWithPriority.timeLapse).toISOString().substring(0,10)
			}
		}
		// eslint-disable-next-line
	}, [operation, supplierWithPriority]);


	useEffect(() => {
		supplierCtl.getAllSuppliersByBrand(brandId, response => {
			setDiscountInformation(response);
			let suppliers = response.map(supplier => ({label: supplier.supplierName, value: supplier.supplierId}))
			setBrandSuppliers(suppliers);
		})
	}, [])

	useEffect(() => {
		supplierCtl.priorityForBrand(brandId, data => {
			if(data.errorMessage === 'Priority record not found' || !data?.isActive){
				setOperation('New');
			} else {
				setOperation('Edit')
				supplierCtl.byId(data.supplierId, supplierData => {
					let currency = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: supplierData.currency ?? 'USD'
					});

					setSupplierWithPriority({...data, cumulativeQuantity: `${data.cumulativeQuantity}`, cumulativeValueFormated: currency.format(data.cumulativeValue)});
				})
			}
		})
	}, []);

	useEffect(() => {
		brandCtl.brand(brandId, (data) =>
	{
		setBrandName(data.name)
		setTitle(data.name);
		setBrandLogoUrl(brandCtl.logo(data.name))
		setLastUpdate(data.updatedAt)
	});
	}, [brandCtl, brandId, setTitle]);

	useEffect(() => {
	brandCtl.pendingPurchaseOrders(brandId, data =>
	{
		let lastOrders = data.splice(0, 5).map(order => ({...order, status: `${order.status}`}));
		table.current && table.current.dataTable.clear().rows.add(lastOrders).draw();
	});
	}, [brandCtl, brandId]);

	useEffect(() => {
		
	cardCtl.allByBrand(brandId, data =>
		{
			data.forEach(item =>
			{
				const dollar = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: item.currency,
				})
				item.variable = item.amount === 0
				item.image = cardCtl.image(item.imageUuid);
				item.amount = dollar.format(item.amount)
				item.maxAmount = dollar.format(item.maxAmount)
				item.minAmount = dollar.format(item.minAmount)
			});
			setcards(data);
		});
	}, [brandId, cardCtl]);

	const giftCardDetail = (data) =>{
	    setGiftCardData(data);
	    setGiftModal(true);
		const	brandId = data?.brandId;
       const supplierId = data?.supplierId
	    setGiftModal(true);
		cardCtl.giftCardDetails(brandId,supplierId, (detailsData)=>{
			setDetilsData(detailsData)
			const status = detailsData?.map(value => value.active)
         const AllStatus = status?.some(value => value === true)
		 setMasterToggle(AllStatus)
		  
		})
	}

	

	const handleActivation = (e, cardId) => {
		const value = e.target.checked;
		const brandId = cardId.brandId
		const giftcardId = cardId.id
		setStatus(value);
		setCardId(giftcardId);
		setBrandId(brandId)
		if(value !== undefined || value !== null){
			toggleConfirm()	
			if(value === true){
				setStatusText("Active")
			}else{
				setStatusText("inActive")
			}
		}
	
		// Update the activation status only for the clicked card
		setActivationStatus(prevStatus => ({
		  ...prevStatus,
		  [cardId.id]: value,
		}));
	  };
	
	const handletoggleGiftcard = () =>{
		let obj ={
			"supplierId": giftCardData?.supplierId,
			"giftCardTypeId": cardId,
			"active": status
		}
		if(obj){
			brandCtl.status(obj,(data)=>{
				if(data && !data.error){
					Notify(alert,"success", "You have change brand status successfully")
					toggleConfirm();
					giftCardDetail(giftCardData);
				}else{
					Notify(alert,"danger",data.errorMessage ?? data.error)
					
				}
			})
		}
		
	}

	const handletoggleGiftcardAll = () =>{
		let obj ={
			"supplierId": giftCardData?.supplierId,
			"brandId": brandId,
			"active": statusAll
		}
		brandCtl.statusAll(obj,(data)=>{
			if(data && !data.error){
				toggleConfirmAll();
				giftCardDetail(giftCardData);
				Notify(alert,"success","All the giftcard status changed successfully")
			}else{
				Notify(alert,"danger",data.errorMessage ?? data.error)
			}
		})

	}


	const handleCloseModaal = () =>{
		toggleConfirm()
		giftCardDetail(giftCardData);
	}
	const handleCloseModaalAll = () =>{
		toggleConfirmAll()
		giftCardDetail(giftCardData);
	}

	return (<>
		<NotificationAlert ref={alert}/>
		<motion.div initial="initial" animate="animate" exit="exit" variants={cardControl} className="content">
			<Row>
				<Col md="6">

					
		<MotionCard variants={fadeIn} className='card-stats'>
		<CardHeader className='brandStatsHeaderContainer'>
			<div className="icon-big text-left icon-warning">
				<i className="nc-icon nc-globe text-success"/>
			</div>
			<p className="card-category brandStatsHeaderTitle">Best supplier for this brand</p>
		</CardHeader>

		<CardBody className='brandStatsBodyContainer'>
			<div style={{ flex: 1, textAlign: 'center' }}>
				<p id="brandName" className="card-category" style={{ textAlign: 'center' }}>{brandName}</p>
				<img id="brandLogo" alt="Brand logo" style={{width: "auto", maxWidth: "180px"}} src={brandLogoUrl}/>
			</div>

			<div className='brandStatsDiscountsTableContainer'>
				<table className='brandStatsDiscountsTable'>
					<thead>
						<tr>
							<th></th>
							<th>Supplier</th>
							<th>Gift Card</th>
							<th>Discount</th>
							<th>Fee</th>
						</tr>
					</thead>
					<tbody>
						{discountInformation.map((discount, index) => (
							<tr key={index} className='space-between-items' style={{fontWeight:"600"}}>
								<th>{index + 1}.</th>
								<th>{discount.supplierName}</th>
								<th><span onClick={()=>giftCardDetail(discount)} style={{cursor:"pointer"}} className={`gift_card ${giftModal && discount.supplierId === giftCardData.supplierId ? "active" : ""}`}>{discount?.size} {discount.size > 1 ? "Gift Cards" : "Gift Card"}</span></th>
								<th>{discount.purchaseDiscount}%</th>
								<th>${discount.purchaseFee}</th>
							</tr>
						)) }
					</tbody>
				</table>
			</div>
		</CardBody>

		<CardFooter className="brandStatsFooterContainer">
			<hr/>
			<div className="stats">
				<i className="far fa-calendar"/>~{lastUpdate}<span id="lastUpdate"/>
			</div>
		</CardFooter>
	</MotionCard>

				</Col>
				<Col md="6">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								<Col md="4" xs="5">
									<div className="icon-big text-left icon-warning">
										<i className="fas fa-medal"/>
									</div>
								</Col>
							</Row>
							{operation === 'Edit' ?
								<div className="mx-5">
									<Row>
										<Col>
											<h5>Supplier: </h5>
										</Col>
										<Col sm={6}>
											<h5>{supplierWithPriority?.supplierName ? supplierWithPriority?.supplierName : 'Not Available'}</h5>
										</Col>
									</Row>
									<Row>
										<Col>
											<h5>Cumulative Value: </h5>
										</Col>
										<Col sm={6}>
											<h5>{supplierWithPriority?.cumulativeValueFormated ? supplierWithPriority?.cumulativeValueFormated  : 'Not Available'}</h5>
										</Col>
									</Row>
									<Row>
										<Col>
											<h5>Cumulative Quantity: </h5>
										</Col>
										<Col sm={6}>
											<h5>{supplierWithPriority?.cumulativeQuantity ? supplierWithPriority.cumulativeQuantity : 'Not Available'}</h5>
										</Col>
									</Row>
									<Row>
										<Col>
											<h5>Time lapse</h5>
										</Col>
										<Col sm={6}>
											<h5>
												{supplierWithPriority?.timeLapse ?
													`${new Date(supplierWithPriority.timeLapse).toLocaleDateString('en-US', {timeZone: 'UTC'})}`
													: 'Undefined'
												}
											</h5>
										</Col>
									</Row>
								</div>
								

								: <>
									<div className="mx-5">
										<Form innerRef={form}>
											<FormGroup row>
												<Label for="supplierPriority" sm={5}><h5>Supplier Priority</h5></Label>
												<Col sm={7}>
													<Select
														ref={select}
														placeholder="Select a Supplier"
														options={brandSuppliers}	
														onChange={option => setSelectedSupplier(option)}
														isClearable
													/>
												</Col>
											</FormGroup>
											<FormGroup row>
												<Label for="cumulativeValue" sm={5}><h5>Cumulative Value</h5></Label>
												<Col sm={7}>
													<Input bsSize="lg" type="number" name="value" id="cumulativeValue" placeholder="value" />
												</Col>
											</FormGroup>
											<FormGroup row>
												<Label for="cumulativeQuantity" sm={5}><h5>Cumulative Quantity</h5></Label>
												<Col sm={7}>
													<Input bsSize="lg" type="number" name="quantity" id="cumulativeQuantity" placeholder="Quantity" />
												</Col>
											</FormGroup>
											<FormGroup row>
												<Label for="timeLapse" sm={5}><h5>Time lapse</h5></Label>
												<Col sm={7}>
													<Input type="date" name="quantity" id="timeLapse" min={new Date().toDateString('en-US')} />
												</Col>
											</FormGroup>
										</Form>
									</div>
								</>
							}
						</CardBody>
						<CardFooter className="my-2">
							<hr />
							<Col md={11} className="justify-content-end text-right">
								<Button type="submit" color={operation === 'Edit' ? 'secondary' : 'btn btn-primaryTwo'} onClick={supplierPriority}>{operation === 'Edit' ? operation : 'Save'}</Button>{' '}
								{operation === 'Save' ? <Button type="submit" color='secondary' onClick={() => setOperation('Edit')}>Cancel</Button> : null} 
							</Col>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
			{giftModal && (
				<Row>
				<Col md="12">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								
								<Col md="2" xs="2">
									<div className="">
										<p className="card-category mb-0" style={{fontSize:"20px",fontWeight:"500",color:"black"}}>Gift Card</p>
										<p style={{marginLeft:"5px",fontSize:"16px"}}>{giftCardData?.supplierName}</p>
									</div>
								</Col>
								<Col md="8" xs="8">
							   <div id="cardContainer" className="" style={{ marginLeft: "-60px" }}>
								<div className="d-flex align-items-center mb-3 toggle_brand_button form-check form-switch">
								<p className="d-inline-block mb-0" style={{ fontSize: "15px",margin:"2px 2px" }}>Inactive</p>
								<input
									className="form-check-input mx-1 position-static"
									type="checkbox"
									role="switch"
									id="masterSwitch"
									checked={masterToggle}
									onChange={handleMasterToggle}
									style={{ cursor: "pointer" }}
								/>
								<p className="mb-0" style={{ fontSize: "15px",margin:"2px 2px" }}>Active <span style={{fontSize:"13px",marginLeft:"2px"}}>(Use this toggle to disable or enable  all gift card types)</span></p>
								</div>
								</div>
								</Col>
								<Col md="2" xs="2" className="d-flex align-items-baseline justify-content-end">
									<div>
									<button type="button" style={{backgroundColor:"transparent",border:"0",fontSize:"22px"}}
									onClick={()=>setGiftModal(false)}
									>x</button>
									</div>
									
								</Col>
							</Row>
							<Row>
								<Col md="12">
									<div id="cardContainer" className="" style={{marginLeft:"30px"}}>
										{
											detailsData.length > 0 &&
											detailsData.map(card => (
												<div className="ncentiva-gift-card-block-big" style={{margin: '15px'}} >
													 <div className="p-2">
													<h4 className="mb-0">{card.productName}</h4>
													<div className=" toggle_brand_button form-check form-switch mb-0 pl-0 d-flex justify-content-between align-items-center">
														<p className="d-inline-block mb-0" style={{fontSize:"13px"}}>Inactive</p>
														<input className="form-check-input mx-1 position-static" type="checkbox" role="switch" id={`flexSwitchCheckDefault-${card.id}`}  checked={activationStatus[card.id] ?? true} onChange={(e) => handleActivation(e,card)} style={{ cursor: "pointer" }} />
														<p className="mb-0" style={{fontSize:"13px"}} htmlFor={`flexSwitchCheckDefault-${card.id}`}>Active</p>
													</div>
													<p className="mb-0">{card?.currency} <span style={{color:"#108ae7"}}>${card.minAmount !== 0 && card.maxAmount !== 0  ? `${card.minAmount} - ${card.maxAmount}` : card.amount}</span></p>
													{/* <p className="mb-0">{card.minAmount !== 0 && card.maxAmount !== 0  ? `${card.minAmount} - ${card.maxAmount}` : card.amount}</p> */}
													</div>
													<img src={cardCtl.image(card?.imageUuid)} alt="card"/>
												</div>
											))
										}
										
									</div>
									
								</Col>
							</Row>
						</CardBody>
					</MotionCard>
				</Col>
				
			</Row>
			)}
			
		</motion.div>
		<Modal isOpen={showConfirm} toggle={toggleConfirm} backdrop="static" centered>
          <ModalHeader className="bg-warning" toggle={handleCloseModaal}>Confirm Brands Status changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to change the brand status to <span style={{color:status === true ? "green" : "red"}}>{statusText}</span>
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleCloseModaal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={handletoggleGiftcard}>Confirm</Button>
          </ModalFooter>
			</Modal>

			<Modal isOpen={showConfirmAll} toggle={toggleConfirmAll} backdrop="static" centered>
          <ModalHeader className="bg-warning" toggle={handleCloseModaalAll}>Confirm  All Brands Status changes </ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to change Allthe brand status to <span style={{color:statusAll === true ? "green" : "red"}}>{statusTextAll}</span>
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleCloseModaalAll}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={handletoggleGiftcardAll}>Confirm</Button>
          </ModalFooter>
			</Modal>
	</>);
}

export default BrandDashboard;



